import { notify } from 'legacy-packages/ft-cb';

const timedAssignmentNotification = (timer, onConfirmClick = () => {}) => {
  const confirmationMessage =
    `You will need <strong>${timer} minutes</strong> to complete this assessment. Once you ` +
    `start it, you will not be able to pause the timer.`;
  notify.cta('This is a Timed Assessment!', confirmationMessage, {
    confirmButtonText: 'Start Assessment',
    onConfirm: () => onConfirmClick(),
  });
};

export default timedAssignmentNotification;
